import { Injectable } from '@angular/core';
import {PasswordHttp} from '@shared/services/http/http-provider.service';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import {PasswordExpiredHttp} from '@shared/services/customer/customer-http.service';


@Injectable({
  providedIn: 'root'
})
export class PasswordService {

  constructor(private http: PasswordHttp,
              private httpExpired: PasswordExpiredHttp) { }

  validateNewPass(email: string, newPassword: string) {

    const body = {
      email: email,
      newPassword: newPassword
    }
    return this.http.sendPostRequest('/validate',
                                      body,
                                      new HttpHeaders(),
                                      new HttpParams());
  }
  changePassword(email: string,
                 currentPass: string,
                 newPassword: string) {

    const body = {
      email: email,
      prevPassword: currentPass,
      newPassword: newPassword,
    }

    return this.http.sendPostRequest('/change',
                                      body,
                                      new HttpHeaders(),
                                      new HttpParams());
  }
  validateExpiredPass(email: string,
                      newPassword: string,
                      token: string) {

    const body = {
      email: email,
      newPassword: newPassword
    }

    return this.httpExpired.sendPostRequest(`/validate?token=${token}`,
        body,
        this.appendPostHeaders(new HttpHeaders()),
        new HttpParams());

  }
  changExpiredPassword(email: string,
                       currentPass: string,
                       newPassword: string,
                       token: string) {

    const body = {
      email: email,
      prevPassword: currentPass,
      newPassword: newPassword
    }

    return this.httpExpired.sendPostRequest(`/change?token=${token}`,
        body,
        this.appendPostHeaders(new HttpHeaders()),
        new HttpParams());
  }
  appendPostHeaders(headers: HttpHeaders) {
    return headers.append('x-api-key',
                          'ISBNUmi5ksDjl2fuznjTpaar8L8hAoawLCGzws70');
  }
  appendGetHeaders(headers: HttpHeaders) {
    return headers.append('x-api-key',
                          'Whi9QqIyLnasPChPwRqgFKdRdpUslxJ54MK72VZ0');
  }




}
